import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
  en: {
    common: {
      app_name: "Oge Eyesthetic Nail Studio",
      sign_in: "Sign in", sign_out: "Sign out", sign_up: "Sign up", email: "Email",
      password: "Password", continue: "Continue", cancel: "Cancel", save: "Save",
      home: "Home", book: "Book", history: "History", profile: "Profile", admin: "Admin",
      tech_dashboard: "Tech Dashboard",
      generate_designs: "Generate 6 Designs",
      pick_time: "Pick a time", reschedule: "Reschedule", cancel_booking: "Cancel",
      leave_review: "Leave review", favorite: "Favorite", share: "Share",
      pay_with_stripe: "Pay with Stripe", total_today: "Total today",
      welcome_back: "Welcome back", you_re_all_set: "You're all set!",
      privacy: "Privacy", terms: "Terms", gallery: "Gallery",
      language: "Language",
    },
  },
  es: {
    common: {
      app_name: "Oge Eyesthetic Estudio de Uñas",
      sign_in: "Iniciar sesión", sign_out: "Cerrar sesión", sign_up: "Registrarse", email: "Correo",
      password: "Contraseña", continue: "Continuar", cancel: "Cancelar", save: "Guardar",
      home: "Inicio", book: "Reservar", history: "Historial", profile: "Perfil", admin: "Admin",
      tech_dashboard: "Panel del técnico",
      generate_designs: "Generar 6 diseños",
      pick_time: "Elegir una hora", reschedule: "Reprogramar", cancel_booking: "Cancelar",
      leave_review: "Dejar reseña", favorite: "Favorito", share: "Compartir",
      pay_with_stripe: "Pagar con Stripe", total_today: "Total hoy",
      welcome_back: "Bienvenida de nuevo", you_re_all_set: "¡Todo listo!",
      privacy: "Privacidad", terms: "Términos", gallery: "Galería",
      language: "Idioma",
    },
  },
  fr: {
    common: {
      app_name: "Oge Eyesthetic Studio d'Ongles",
      sign_in: "Se connecter", sign_out: "Se déconnecter", sign_up: "S'inscrire", email: "Email",
      password: "Mot de passe", continue: "Continuer", cancel: "Annuler", save: "Enregistrer",
      home: "Accueil", book: "Réserver", history: "Historique", profile: "Profil", admin: "Admin",
      tech_dashboard: "Tableau de la technicienne",
      generate_designs: "Générer 6 modèles",
      pick_time: "Choisir un horaire", reschedule: "Reporter", cancel_booking: "Annuler",
      leave_review: "Laisser un avis", favorite: "Favori", share: "Partager",
      pay_with_stripe: "Payer avec Stripe", total_today: "Total aujourd'hui",
      welcome_back: "Bon retour", you_re_all_set: "Tout est prêt!",
      privacy: "Confidentialité", terms: "Conditions", gallery: "Galerie",
      language: "Langue",
    },
  },
};

const KEY = "oge.locale";
const initial = (() => {
  try {
    const v = localStorage.getItem(KEY);
    if (v) return v;
  } catch {}
  return (typeof navigator !== "undefined" ? navigator.language?.slice(0, 2) : "en") || "en";
})();

i18n.use(initReactI18next).init({
  resources,
  lng: ["en", "es", "fr"].includes(initial) ? initial : "en",
  fallbackLng: "en",
  defaultNS: "common",
  interpolation: { escapeValue: false },
});

export function setLocale(lng) {
  i18n.changeLanguage(lng);
  try { localStorage.setItem(KEY, lng); } catch {}
}

export default i18n;
